import e from "../../utils/classNames.js";
import t from "../popover/Popover.js";
import { forwardRef as n } from "react";
import { noop as r } from "es-toolkit/compat";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarOverlay.tsx
var o = 250, s = n((n, s) => {
	let { children: c, show: l, preRender: u, id: d, title: f, onClick: p = r, width: m = o, style: h = {}, className: g, ..._ } = n, v = {
		"--anchor-offset-block": "5px",
		"--action-bar-overlay-width": `${m}px`,
		"--overlay-arrow-offset-inline": "calc((var(--action-bar-overlay-width) - var(--overlay-anchor-width, 0px)) / 2)",
		...h,
		width: m
	}, y = e("ActionBarOverlay", g, u && !l && "position-offscreen"), b = e("ActionBarItemPopover text-color-dark", g), x = e("ActionBarItemPopover", g);
	return /* @__PURE__ */ a(t, {
		ref: s,
		id: d,
		onClick: p,
		..._,
		style: v,
		className: y,
		children: [f && /* @__PURE__ */ i(t.Title, {
			className: b,
			children: f
		}), /* @__PURE__ */ i(t.Content, {
			className: x,
			children: c
		})]
	});
});
//#endregion
export { s as default };

//# sourceMappingURL=ActionBarOverlay.js.map